import React from 'react'

import { isNil } from 'ramda'

import { Flex, Link, Text } from '@driftt/dds'
import { CubeQueryStringAdapter } from '@driftt/dds.reports'

import { ReportKPICard, Score } from 'components/KPICard'
import { ROI_OPPORTUNITY_REPORT_PATH } from 'layouts/RevenueReport/RevenueReport.constants'
import { TypeFormats } from 'utils/format'

import useRevenuePipelineKPI from './TotalRevenuePipeline.hooks'

export const TotalRevenuePipeline = ({ isInfluenced, isSourced }) => {
  const {
    influencedOpportunityPipelineCount,
    opportunityTotalCount,
    opportunityPipelineAmountSum,
    isLoading,
    hasNoData,
    hasError,
    opportunityPipelineAmountSumCubeQuery,
  } = useRevenuePipelineKPI({
    isInfluenced,
    isSourced,
  })

  const drillDownQueryString = CubeQueryStringAdapter.toQueryString(
    opportunityPipelineAmountSumCubeQuery
  )

  return (
    <ReportKPICard
      title="Total Pipeline"
      isLoading={isLoading}
      isError={hasError}
      hasNoData={hasNoData}
      subtitle="Opportunities where at least one associated contact engaged with Drift"
      score={Score.None}
      metric={opportunityPipelineAmountSum}
      metricRange={''}
      formatMetric={(responseRate: number) =>
        TypeFormats.CURRENCY(responseRate)
      }
      childrenFlexGap={2}
    >
      {!isNil(influencedOpportunityPipelineCount) && (
        <Text variant="body">
          <b>{influencedOpportunityPipelineCount}</b> opportunities in pipeline
        </Text>
      )}
      {!!opportunityTotalCount && (
        <Flex gap="half" direction="column" grow={0}>
          <Text variant="bodyBold">
            {TypeFormats.PERCENT_WITH_DECIMAL(opportunityTotalCount)} of total
            pipeline
          </Text>
          <Text variant="metadata">opportunities were influenced by Drift</Text>
        </Flex>
      )}
      <Link
        target="_blank"
        variant="inline"
        href={`${ROI_OPPORTUNITY_REPORT_PATH}?${drillDownQueryString}`}
      >
        View data
      </Link>
    </ReportKPICard>
  )
}
